import { Pipe, PipeTransform } from '@angular/core';
import { castToPersonDisplayData, getDisplayName, Person, PersonDisplayData } from '@lib/api/models/person';

@Pipe({
    standalone: true,
    name: 'personInfo'
})

export class PersonInfoPipe implements PipeTransform {
    transform(person: PersonDisplayData | Person | undefined): string {
        if (!person) {
            return '';
        }
        const displayData = 'id' in person ? castToPersonDisplayData(person) : person;
        return getDisplayName(displayData, true, false, true);
    }
}

@Pipe({
    standalone: true,
    name: 'personName'
})
export class PersonNamePipe implements PipeTransform {
    transform(person: PersonDisplayData | Person | undefined): string {
        if (!person) {
            return '';
        }
        const displayData = 'id' in person ? castToPersonDisplayData(person) : person;
        return getDisplayName(displayData);
    }
}


